import styled from 'styled-components'
import { default as VARIABLES } from '../../themes/styles/variables'

import { ICONS } from '../../themes'
// Wrapper
// ============================================================
export const SourcingDetailBuyerFormStyled = styled.div`
  /* Parent styles
  ------------------------------- */
  width: 100%;

  /* Child element styles
  ------------------------------- */
  .form-group-attached-file {
    min-width: 0;
    flex-wrap: wrap;
    display: flex;
    column-gap: 10px;
    row-gap: 5px;
  }

  /* Modifiers
  ------------------------------- */
  #actions {
    display: block;
  }
  .checkbox-minimum-bid {
    /* width: 105px; */
    &.checkbox-is-error {
      color: #aaaaaa;
    }
  }
  .main-content .content-body .form-actions .button-group + .button-group {
    width: auto;
  }

  .table-wrapper {
    margin-top: 21px;
  }

  .form-row.form-row-title {
    margin-bottom: 11px;
    margin-top: 21px;
  }

  .create-event {
    color: ${VARIABLES.COLORS.BLUE_1};

    .form-group {
      > label {
        flex: 0 0 165px;
      }

      &.date-period {
        .date-picker-wrapper {
          width: 100%;
          max-width: 500px;
          min-width: 250px;
        }
      }

      .input-control {
        max-width: 100%;
        min-width: auto;
      }

      .input-textarea-control {
        max-width: 100%;
      }

      .input-upload-control {
        max-width: fit-content;
        min-width: auto;
      }

      .form-group-inner-wrapper {
        .download-excel-button {
          width: 170px;
        }
        .browse-file {
          min-width: 170px;
        }
      }
    }

    .form-col.col-6 {
      max-width: 690px;
    }

    .fake-label {
      color: ${VARIABLES.COLORS.BLUE_1};
    }
  }

  .sourcing-item {
    margin-top: 10px;

    .sourcing-item-add {
      .description {
        height: auto;

        .textarea {
          max-width: 100%;
          min-width: 100%;
        }
      }

      .select-control {
        min-width: 100%;
      }

      .actions {
        padding-left: 0;
      }

      .actionEdit {
        flex-direction: column;
        padding-left: 5px;
        padding-right: 5px;
        min-width: 100px;
      }
    }

    .price {
      .form-group {
        .section {
          margin-bottom: 0;
        }
      }
    }

    .form-group {
      .form-group-control {
        max-width: 100%;
      }
    }

    .item-name {
      .attached-file-list {
        a.file-link {
          /* max-width: 250px; */
          max-width: 100%;
          margin-right: 0;
        }
      }
    }
  }

  .add-supplier {
    .table-wrapper {
      overflow: auto;
      flex-wrap: wrap;
      max-height: 270px;

      /* width */
      ::-webkit-scrollbar {
        width: 10px;
        height: 10px;
      }

      /* Track */
      ::-webkit-scrollbar-track {
        background: ${VARIABLES.COLORS.GRAY_2};
        border-radius: ${VARIABLES.BORDER_RADIUSES.XXS};
      }

      /* Handle */
      ::-webkit-scrollbar-thumb {
        background: ${VARIABLES.COLORS.BLUE_4};
        border-radius: ${VARIABLES.BORDER_RADIUSES.XXS};
      }

      /* Handle on hover */
      ::-webkit-scrollbar-thumb:hover {
        background: ${VARIABLES.COLORS.BLUE_1};
      }
    }

    .page-button {
      justify-content: flex-end;
    }

    .company-name {
      flex: 0 0 19%;
      min-width: auto;

      .wrong-icon {
        margin-left: 10px;
      }
    }

    .email {
      flex: 0 0 15%;
    }

    .actions {
      text-align: center;
      justify-content: center;
      flex: 0 0 10%;
      .section {
        justify-content: center;
      }
    }

    .form-group {
      .select-control {
        min-width: auto;
        max-width: 105px;
        margin-left: 10px;
      }
    }
  }

  /* .form-group .message {
    height: auto;
  } */

  .multi-select {
    width: 495px;
  }

  .stepper {
    color: ${VARIABLES.COLORS.GRAY_5};
    justify-content: center;
    margin-bottom: 45px;
  }

  .stepper-indicator {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
  }

  .stepper-inner {
    width: 20em;
    text-align: center;
    cursor: pointer;
    position: relative;
    &:after {
      width: 100%;
      height: 2px;
      position: absolute;
      top: 35px;
      left: 40px;
      background-color: ${VARIABLES.COLORS.GRAY_5};
      content: '';
    }

    &:first-child:after {
      left: 50%;
    }

    &:last-child:after {
      left: 0;
      width: 50%;
    }
  }

  .stepper-number {
    display: inline-block;
    width: 70px;
    height: 70px;
    line-height: 70px;
    border-radius: 50%;
    position: relative;
    text-align: center;
    z-index: 1;
    border: 2px solid ${VARIABLES.COLORS.GRAY_5};
    background-color: white;
    color: ${VARIABLES.COLORS.GRAY_5};

    span {
      font-size: 25px;
    }

    &.active {
      border-color: ${VARIABLES.COLORS.BLUE_1};
      color: ${VARIABLES.COLORS.BLUE_1};
      background-color: white;
    }

    &.success {
      border-color: ${VARIABLES.COLORS.GREEN_1};
      color: ${VARIABLES.COLORS.GREEN_1};
      background-color: white;
    }
  }

  .stepper-label {
    margin-top: 16px;
    margin-bottom: 16px;
    height: 24px;
    text-align: center;
    width: 100%;

    &.active {
      color: ${VARIABLES.COLORS.BLUE_1};
    }

    &.success {
      color: ${VARIABLES.COLORS.GREEN_1};
    }
  }

  .add-new {
    margin-bottom: 10px;
    width: 100%;
  }

  .attached-file-list {
    margin-top: 10px;

    .file-name {
      /* margin-right: 10px; */
      margin-left: 20px;
    }
  }

  .form-group .message {
    white-space: normal;
    text-align: left;
  }

  .step-2 {
    .section {
      &.table-wrapper {
        //overflow: initial;
      }
    }

    .form-group-header {
      margin-bottom: 10px;
    }
  }

  .loading {
    justify-content: center;
    align-items: center;
    margin-top: 20%;
  }

  .download-excel-button {
    min-width: 160px;
  }

  .input-text-right {
    .input {
      text-align: right;
      justify-content: end;
    }
  }

  /* Media queries
  ------------------------------- */
  @media all and (min-width: 1228.98px) {
    .form-wrapper:has(.input-event-name > input:focus) {
      .vat,
      .description,
      .currency,
      .internal-note,
      .purchasing-type,
      .seal-envelope,
      .internal-attachment,
      .auction-type,
      .opening-price,
      .extension-time,
      .bid-submission,
      .max-extension-time,
      .display-dummy {
        color: #06304f;
      }
    }
    .form-wrapper:has(.input-description > textarea:focus) {
      .currency,
      .internal-note,
      .purchasing-type,
      .seal-envelope,
      .internal-attachment,
      .auction-type,
      .opening-price,
      .extension-time,
      .bid-submission,
      .max-extension-time,
      .display-dummy {
        color: #06304f;
      }
    }
    .form-wrapper:has(.input-internal-note > textarea:focus) {
      .internal-attachment {
        color: #06304f;
      }
    }
  }
  @media all and (max-width: 1600.98px) {
    .download-excel-button {
      min-width: 130px;
    }

    .stepper {
      margin-bottom: 40px;
    }

    .stepper-inner {
      &:after {
        top: 32px;
      }
    }

    .stepper-number {
      width: 65px;
      height: 65px;
      line-height: 65px;

      span {
        font-size: 23px;
      }
    }

    .stepper-label {
      margin-top: 14px;
      margin-bottom: 14px;
      height: 22px;
    }
  }

  @media all and (max-width: 1480px) {
    .time,
    .minutes {
      .input {
        padding: 0 4px;
      }
    }
  }

  @media all and (max-width: 1440.98px) {
    .limited {
      margin-right: 4px;
    }
    .stepper {
      margin-bottom: 30px;
    }

    .stepper-inner {
      &:after {
        top: 29px;
      }
    }

    .stepper-number {
      width: 60px;
      height: 60px;
      line-height: 60px;

      span {
        font-size: 21px;
      }
    }

    .stepper-label {
      margin-top: 12px;
      margin-bottom: 12px;
      height: 20px;
    }
  }

  @media all and (max-width: 1366.98px) {
    .stepper {
      margin-bottom: 20px;
    }

    .stepper-inner {
      &:after {
        top: 26px;
      }
    }

    .stepper-number {
      width: 55px;
      height: 55px;
      line-height: 55px;

      span {
        font-size: 19px;
      }
    }

    .stepper-label {
      margin-top: 10px;
      margin-bottom: 10px;
      height: 18px;
    }
  }

  @media all and (max-width: 1280.98px) {
    .time,
    .minutes {
      .input {
        padding: 0 12px;
      }
    }

    .stepper {
      margin-bottom: 18px;
    }

    .stepper-inner {
      &:after {
        top: 24px;
      }
    }

    .stepper-number {
      width: 50px;
      height: 50px;
      line-height: 50px;

      span {
        font-size: 17px;
      }
    }

    .stepper-label {
      margin-top: 8px;
      margin-bottom: 8px;
      height: 16px;
    }
  }

  @media all and (max-width: 1024.98px) {
    .stepper {
      margin-bottom: 15px;
    }

    .stepper-inner {
      &:after {
        top: 22px;
        height: 1px;
      }
    }

    .stepper-number {
      width: 45px;
      height: 45px;
      line-height: 45px;
      border-width: 1px;

      span {
        font-size: 15px;
      }
    }

    .stepper-label {
      margin-top: 6px;
      margin-bottom: 6px;
      height: 15px;
    }
  }
`

export const SourcingDetailSupplierFormStyled = styled.div`
  /* Parent styles
  ------------------------------- */
  width: 100%;

  /* Child element styles
  ------------------------------- */

  /* Modifiers
  ------------------------------- */

  .bid-history {
    .no-result-found {
      padding-bottom: 2rem;
      padding-top: 1.5rem;
    }
  }

  .main-content .content-body .form-actions {
    padding: 0;
    .button-group + .button-group {
      width: auto;
    }
  }

  .loading {
    justify-content: center;
    align-items: center;
  }

  .table-wrapper {
    margin-top: 21px;
  }

  .create-event {
    color: ${VARIABLES.COLORS.BLUE_1};

    .form-group {
      > label {
        flex: 0 0 165px;
      }

      .input-control {
        max-width: 100%;
      }

      &.is-error {
        .number-format input {
          border-color: ${VARIABLES.COLORS.RED_1};
        }
      }

      .input-textarea-control {
        max-width: 100%;
      }

      .input-upload-control {
        max-width: fit-content;
        min-width: auto;
      }

      .form-group-inner-wrapper {
        .download-excel-button {
          width: 170px;
        }
        .browse-file {
          min-width: 170px;
        }
      }
    }

    .form-col.col-6 {
      max-width: 690px;
      align-content: flex-start;
    }

    .fake-label {
      color: ${VARIABLES.COLORS.BLUE_1};
    }
  }

  .sourcing-item {
    margin-top: 10px;

    .table-row {
      .item-name {
        flex: 0 0 17%;
      }
    }
  }

  .add-supplier {
    .table-wrapper {
      overflow: hidden;
    }

    .page-button {
      justify-content: flex-end;
    }

    .company-name {
      flex: 0 0 19%;
      min-width: auto;
    }

    .email {
      flex: 0 0 15%;
    }

    .actions {
      .section {
        justify-content: center;
      }
    }

    .form-group {
      .select-control {
        min-width: auto;
        max-width: 105px;
        margin-left: 10px;
      }
    }
  }

  .stepper {
    color: ${VARIABLES.COLORS.GRAY_5};
    justify-content: center;
    margin-bottom: 45px;
  }

  .stepper-indicator {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
  }

  .stepper-inner {
    width: 25em;
    text-align: center;
    cursor: pointer;
    position: relative;
    &:after {
      width: 100%;
      height: 2px;
      position: absolute;
      top: 35px;
      left: 40px;
      background-color: ${VARIABLES.COLORS.GRAY_5};
      content: '';
    }

    &:first-child:after {
      left: 50%;
    }

    &:last-child:after {
      left: 0;
      width: 50%;
    }
  }

  .stepper-number {
    display: inline-block;
    width: 70px;
    height: 70px;
    line-height: 70px;
    border-radius: 50%;
    position: relative;
    text-align: center;
    z-index: 1;
    border: 2px solid ${VARIABLES.COLORS.GRAY_5};
    background-color: white;
    color: ${VARIABLES.COLORS.GRAY_5};

    span {
      font-size: 25px;
    }

    &.active {
      border-color: ${VARIABLES.COLORS.BLUE_1};
      color: ${VARIABLES.COLORS.BLUE_1};
      background-color: white;
    }
  }

  .stepper-label {
    margin-top: 16px;
    margin-bottom: 16px;
    height: 24px;
    text-align: center;
    width: 100%;

    &.active {
      color: ${VARIABLES.COLORS.BLUE_1};
    }
  }

  .rfq-info,
  .bid-history {
    &.table-header-freeze-wrapper {
      overflow-x: auto;
      margin-bottom: 10px;
      max-height: 515px;

      ::-webkit-scrollbar {
        width: 10px;
        height: 10px;
      }

      /* Track */
      ::-webkit-scrollbar-track {
        background: ${VARIABLES.COLORS.GRAY_2};
        border-radius: ${VARIABLES.BORDER_RADIUSES.XXS};
      }

      /* Handle */
      ::-webkit-scrollbar-thumb {
        background: ${VARIABLES.COLORS.BLUE_1};
        border-radius: ${VARIABLES.BORDER_RADIUSES.XXS};
      }

      /* Handle on hover */
      ::-webkit-scrollbar-thumb:hover {
        background: ${VARIABLES.COLORS.BLUE_4};
      }
    }

    .attachment {
      .form-group-control {
        margin-bottom: 10px;
        flex-wrap: wrap;

        .form-group-inner-wrapper {
          margin: 0 auto 10px;
        }
      }
    }
  }

  .table-wrapper {
    margin-top: 21px;
  }

  .table-column {
    height: auto;
    max-height: inherit;
  }

  .table {
    .table-row {
      .item-name {
        flex: 0 0 16%;
        min-width: 150px;
        text-align: left;
        justify-content: left;
        white-space: normal;
        word-wrap: break-word;
      }

      .description {
        flex: 0 0 18%;
        min-width: 160px;
        text-align: left;
        justify-content: left;
        word-wrap: break-word;
        hyphens: auto;
        white-space: normal;

        .attached-file-list {
          justify-content: left;

          a {
            &.file-link {
              max-width: 100%;
            }
          }
        }

        &-item {
          margin-bottom: 10px;
          display: block;
        }
      }

      .quantity {
        flex: 0 0 11%;
        min-width: 110px;
        text-align: center;
        justify-content: center;
      }

      .uom {
        flex: 0 0 10%;
        min-width: 110px;
        text-align: center;
        justify-content: center;
      }

      .unit-price {
        flex: 0 0 15%;
        min-width: 140px;
        text-align: center;
        justify-content: center;
      }

      .total-price {
        flex: 0 0 17%;
        min-width: 160px;
        text-align: center;
        justify-content: center;
        /* padding-top: 0; */
      }

      .table-column {
        &.total-price {
          /* padding-top: 19px; */
        }
      }

      .attachment {
        flex: 0 0 18%;
        min-width: 200px;
        text-align: center;
        justify-content: center;

        .attached-file-list {
          a {
            &.file-link {
              max-width: 100%;
            }
          }
        }
      }

      .note-buyer {
        flex: 0 0 19%;
        min-width: 230px;
        text-align: center;
        justify-content: center;

        .textarea {
          min-width: 180px;
          width: 100%;
          min-height: 100px;
          max-height: 100px;
        }
      }

      .status {
        flex: 0 0 10%;
        text-align: center;
        justify-content: center;
      }
    }
  }
  .bid-history {
    .bid-no {
      flex: 0 0 18%;
      justify-content: center;
      text-align: center;
    }

    .total-bid-amount {
      flex: 0 0 32%;
      padding-right: 70px;
      justify-content: end;
      text-align: right;
    }

    .bid-time {
      flex: 0 0 30%;
      justify-content: center;
      text-align: center;
    }

    .view-more {
      flex: 0 0 20%;
      justify-content: center;
      text-align: center;
    }
  }
  .auction-info .info {
    .no {
      flex: 0 0 8%;
    }
    .item-name {
      flex: 0 0 23%;
    }
    .description {
      flex: 0 0 23%;
    }
    .quantity {
      flex: 0 0 23%;
    }
    .uom {
      flex: 0 0 23%;
    }
  }
  .auction-info .more {
    .no {
      flex: 0 0 6%;
    }
    .item-name {
      flex: 0 0 16%;
    }
    .description {
      flex: 0 0 14%;
    }
    .quantity {
      flex: 0 0 10%;
    }
    .uom {
      flex: 0 0 8%;
    }
    .unit-price {
      justify-content: end;
      text-align: right;
      flex: 0 0 22%;
    }
    .total-price {
      padding-right: 30px;
      justify-content: end;
      text-align: right;
      flex: 0 0 24%;
    }
  }
  .list {
    display: block;
    max-height: 400px;
    overflow: auto;
    overflow-y: overlay;
    ::-webkit-scrollbar {
      width: 10px;
      height: 10px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
      background: ${VARIABLES.COLORS.GRAY_2};
      border-radius: ${VARIABLES.BORDER_RADIUSES.XXS};
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: ${VARIABLES.COLORS.BLUE_4};
      border-radius: ${VARIABLES.BORDER_RADIUSES.XXS};
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: ${VARIABLES.COLORS.BLUE_1};
    }
  }
  .files-wrapper {
    justify-content: center;

    .button {
      &.file-link {
        background-color: transparent;
        color: ${VARIABLES.COLORS.BLUE_2};
        border: none;
        display: inline-flex;
        align-items: center;
        padding: 30px 17px 7px;
        width: auto;
        max-width: 500px;
        border-radius: ${VARIABLES.BORDER_RADIUSES.XS};
        text-decoration: none;
        margin-bottom: 10px;
        position: relative;
        max-width: 100%;
        cursor: pointer;

        .file-name {
          width: 100%;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-weight: normal;
          text-decoration: underline;
          margin-right: 5px;
        }

        &:before {
          content: '';
          display: inline-block;
          background-image: url(${ICONS['icon-download-file.png']});
          width: 13px;
          height: 16px;
          position: absolute;
          top: 0;
          left: 50%;
          transform: translateX(-50%);
        }

        .button {
          flex: 0 0 16px;
          margin-left: 25px;

          .delete-circle-icon {
            flex: 0 0 16px;
          }

          &:hover {
            filter: brightness(0.8);
          }
        }
      }

      &:hover {
        color: ${VARIABLES.COLORS.BLUE_5};
      }
    }
  }

  .form-group .form-group-inner-wrapper {
    flex-wrap: wrap;
    position: relative;
  }

  .attached-file-list {
    justify-content: center;

    a.file-link {
      cursor: pointer;
      /* max-width: 240px; */
      /* margin-right: 0; */
    }
  }

  .attachment-row {
    .attached-file-list {
      justify-content: left;
    }

    .input-attach {
      width: 125px;
      margin-bottom: 10px;
    }
  }

  .total-price {
    justify-content: flex-end;
    label {
      margin-right: 15px;
    }
  }

  .show-total-price {
    cursor: default;
    border: 0;
  }

  .reject-text {
    color: ${VARIABLES.COLORS.RED_1};
  }

  .rfq-status-attach {
    margin-left: 55px;
  }

  .rfq_status {
    position: relative;

    .image-control {
      position: absolute;
      right: 15px;
      cursor: pointer;
    }
  }

  .input-attach {
    position: relative;
    .btn-array-upload {
      width: 125px;
      height: 42px;
      overflow: hidden;
      position: absolute;
      z-index: 1;
      cursor: pointer;
      text-indent: -9999px;

      &.is-disabled {
        background-color: ${VARIABLES.COLORS.GRAY_9};
        cursor: not-allowed;
      }
    }

    .disabled {
      cursor: default;
    }

    .button-upload-files {
      width: 125px;
      height: 42px;
      border-radius: 6px;
      cursor: pointer;
      color: white;
      background-color: ${VARIABLES.COLORS.BLUE_1};
      font-weight: 600;
      font-size: 17px;
      white-space: nowrap;
      display: flex;
      align-items: center;
      justify-content: center;
      &:hover {
        background-color: ${VARIABLES.COLORS.BLUE_3};
        cursor: pointer;
      }

      &.is-disabled {
        background-color: ${VARIABLES.COLORS.GRAY_9};
        cursor: not-allowed;
      }
    }
  }

  .download-excel-button {
    min-width: 160px;
  }

  .tooltip-attachment {
    position: absolute;
    right: 20px;
    width: 18px;
  }

  /* Media queries
  ------------------------------- */
  @media all and (max-width: 1600.98px) {
    .stepper {
      margin-bottom: 40px;
    }

    .stepper-inner {
      &:after {
        top: 32px;
      }
    }

    .stepper-number {
      width: 65px;
      height: 65px;
      line-height: 65px;

      span {
        font-size: 23px;
      }
    }

    .stepper-label {
      margin-top: 14px;
      margin-bottom: 14px;
      height: 22px;
    }

    .attachment-row {
      .input-attach {
        position: relative;
        width: 125px;
      }
    }

    .input-attach {
      position: relative;
      width: 120px;

      .btn-array-upload,
      .button-upload-files {
        width: 120px;
        height: 40px;
        font-size: 16px;
      }
    }

    .download-excel-button {
      min-width: 130px;
    }
  }

  @media all and (max-width: 1440.98px) {
    .stepper {
      margin-bottom: 30px;
    }

    .stepper-inner {
      &:after {
        top: 29px;
      }
    }

    .stepper-number {
      width: 60px;
      height: 60px;
      line-height: 60px;

      span {
        font-size: 21px;
      }
    }

    .stepper-label {
      margin-top: 12px;
      margin-bottom: 12px;
      height: 20px;
    }

    .attachment-row {
      .input-attach {
        position: relative;
        width: 120px;
      }
    }

    .input-attach {
      position: relative;
      width: 115px;

      .btn-array-upload,
      .button-upload-files {
        width: 115px;
        height: 38px;
        font-size: 15px;
      }
    }
  }

  @media all and (max-width: 1366.98px) {
    .stepper {
      margin-bottom: 20px;
    }

    .stepper-inner {
      &:after {
        top: 26px;
      }
    }

    .stepper-number {
      width: 55px;
      height: 55px;
      line-height: 55px;

      span {
        font-size: 19px;
      }
    }

    .stepper-label {
      margin-top: 10px;
      margin-bottom: 10px;
      height: 18px;
    }

    .attachment-row {
      .input-attach {
        position: relative;
        width: 115px;
      }
    }

    .input-attach {
      position: relative;
      width: 110px;

      .btn-array-upload,
      .button-upload-files {
        width: 110px;
        height: 36px;
        font-size: 14px;
      }
    }
  }

  @media all and (max-width: 1280.98px) {
    .stepper {
      margin-bottom: 18px;
    }

    .stepper-inner {
      &:after {
        top: 24px;
      }
    }

    .stepper-number {
      width: 50px;
      height: 50px;
      line-height: 50px;

      span {
        font-size: 17px;
      }
    }

    .stepper-label {
      margin-top: 8px;
      margin-bottom: 8px;
      height: 16px;
    }

    .attachment-row {
      .input-attach {
        position: relative;
        width: 110px;
      }
    }

    .input-attach {
      position: relative;
      width: 105px;

      .btn-array-upload,
      .button-upload-files {
        width: 105px;
        height: 34px;
        font-size: 13px;
      }
    }
  }

  @media all and (max-width: 1024.98px) {
    .stepper {
      margin-bottom: 15px;
    }

    .stepper-inner {
      &:after {
        top: 22px;
        height: 1px;
      }
    }

    .stepper-number {
      width: 45px;
      height: 45px;
      line-height: 45px;
      border-width: 1px;

      span {
        font-size: 15px;
      }
    }

    .stepper-label {
      margin-top: 6px;
      margin-bottom: 6px;
      height: 15px;
    }

    .attachment-row {
      .input-attach {
        position: relative;
        width: 105px;
      }
    }

    .input-attach {
      position: relative;
      width: 100px;

      .btn-array-upload,
      .button-upload-files {
        width: 100px;
        height: 32px;
        font-size: 12px;
      }
    }
  }
  @media all and (max-width: 977px) {
    .list {
      padding: 0;
      margin: 0;
      overflow-x: hidden;
    }
  }
`
